/** @format */
// 车场运行状态，  01：正式运营 02：试运营  03：已停用
export enum propertyCarStatus {
  Wait = '01',
  Effects = '02',
  Expired = '03'
}

export const propertyCarStatusMap: {
  [key: string]: string;
} = {
  [propertyCarStatus.Wait]: '正式运营',
  [propertyCarStatus.Effects]: '试运营',
  [propertyCarStatus.Expired]: '已停用'
};

// 统计颗粒度 00:日报  01:月报  02:季报  03:年报
export enum longRentalStatus {
  Wait = '00',
  Normal = '01',
  Expired = '02',
  Finish = '03'
}

export const longRentalStatusMap: {
  [key: string]: string;
} = {
  [longRentalStatus.Wait]: '日报',
  [longRentalStatus.Normal]: '月报',
  [longRentalStatus.Expired]: '季报',
  [longRentalStatus.Finish]: '年报'
};

// 长租车车位类型  0: '产权车位',1: '人防车位',2: '自划车位',3: '非固定车位'
export enum longRentalCarType {
  Auth = '0',
  Civil = '1',
  Self = '2',
  NoFixed = '3'
}

export const longRentalCarTypeMap: {
  [key: string]: string;
} = {
  [longRentalCarType.Auth]: '产权车位',
  [longRentalCarType.Civil]: '人防车位',
  [longRentalCarType.Self]: '自划车位',
  [longRentalCarType.NoFixed]: '非固定车位'
};

// 长租车签约申请状态  0: '待审核',1: '审核不通过',2: '审核通过'
export enum longRentalApplyStatus {
  Wait = '01',
  NoPass = '02',
  Pass = '03',
  Failure = '04'
}

export const longRentalApplyStatusMap: {
  [key: string]: string;
} = {
  [longRentalApplyStatus.Wait]: '待审核',
  [longRentalApplyStatus.NoPass]: '审核不通过',
  [longRentalApplyStatus.Pass]: '审核通过',
  [longRentalApplyStatus.Failure]: '已失效'
};

// 长租车签约支付状态  01: '已支付',02: '已失效',03: '待支付'
export enum longRentalPayStatus {
  Payed = '01',
  Failure = '02',
  Wait = '03'
}

export const longRentalPayStatusMap: {
  [key: string]: string;
} = {
  [longRentalPayStatus.Payed]: '已支付',
  [longRentalPayStatus.Failure]: '已失效',
  [longRentalPayStatus.Wait]: '待支付'
};

// 长租车签约业务类型  0: '开卡',1: '续费'
export enum longRentalBussinessType {
  Open = '0',
  Renew = '1'
}

export const longRentalBussinessTypeMap: {
  [key: string]: string;
} = {
  [longRentalBussinessType.Open]: '开卡',
  [longRentalBussinessType.Renew]: '续费'
};

// 固定车辆交易记录  0: '平台',1: '第三方',2: 'C端微站点'
export enum TraderecordChannel {
  Platform = '01',
  ThirdParty = '02',
  CSide = '03'
}

export const TraderecordChannelMap: {
  [key: string]: string;
} = {
  [TraderecordChannel.Platform]: '平台',
  [TraderecordChannel.ThirdParty]: '第三方',
  [TraderecordChannel.CSide]: 'C端微站点'
};

// 固定车辆业务类型  0: '产权',1: '长租'
export enum TraderecordBussinessType {
  PropertyCar = '01',
  LongRental = '02'
}

export const TraderecordBussinessTypeMap: {
  [key: string]: string;
} = {
  [TraderecordBussinessType.PropertyCar]: '产权车',
  [TraderecordBussinessType.LongRental]: '长租车'
};

// 固定车辆交易类型  0: '新办',1: '续费',2: '退费'
export enum TraderecordPayType {
  New = '01',
  Renew = '02',
  Refund = '03'
}

export const TraderecordPayTypeMap: {
  [key: string]: string;
} = {
  [TraderecordPayType.New]: '新办',
  [TraderecordPayType.Renew]: '续费',
  [TraderecordPayType.Refund]: '退费'
};

// 固定车辆缴费方式，多个逗号拼接。01:现金 02:微信 03:支付宝 04:银行转账
export enum TraderecordPayMethods {
  New = '01',
  WeiXin = '02',
  Alipay = '03',
  Other = '04'
}

export const TraderecordPayMethodsMap: {
  [key: string]: string;
} = {
  [TraderecordPayMethods.New]: '现金',
  [TraderecordPayMethods.WeiXin]: '微信',
  [TraderecordPayMethods.Alipay]: '支付宝',
  [TraderecordPayMethods.Other]: '其他'
};
// 下账状态
export enum tollManList {
  entryMan = '00',
  centerMan = '01',
  auto = '02',
  moveMan = '03'
}

export const tollManMap: {
  [key: string]: string;
} = {
  [tollManList.entryMan]: '出口岗亭',
  [tollManList.centerMan]: '中央缴费处收费员',
  [tollManList.auto]: '自助缴费机',
  [tollManList.moveMan]: '移动岗亭'
};

// 修正来源 00 本地 01 平台
export enum reviseFrom {
  localForm = '00',
  platform = '01'
}

export const reviseFromMap: {
  [key: string]: string;
} = {
  [reviseFrom.localForm]: '本地',
  [reviseFrom.platform]: '平台'
};
